import React, { useEffect } from 'react'
import MUIDataTable from "mui-datatables";
import EditIcon from '@material-ui/icons/Edit';
import { createMuiTheme, MuiThemeProvider, Switch, TableCell, Typography, withStyles } from "@material-ui/core";
import AddPasien from '../MasterData/addPasien';
import AddDocter from '../MasterData/addDocter';
import DetailDocter from '../MasterData/detailDocter';
import FilterDocter from '../MasterData/filterDokter';
import { getDocter } from '../../store/actions/dokterAction';
import { useDispatch, useSelector } from 'react-redux';
import editIcon from '../../assets/ic_detail.png';
import print from '../../assets/ic_print.png';
import api from '../api';
import { useHistory } from 'react-router';
import download from '../../assets/ic_downloadFile.png';

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptionsDownload()

const IconSwitch = withStyles((theme) => ({
    root: {
        width: 36,
        height: 20,
        padding: 0,
        margin: theme.spacing(0),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 20,
        height: 20,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});


export default function RiwayatPembayaran(props) {
    const history = useHistory()
    const [visibleCreate, setVisibleCreate] = React.useState(false);
    const [visibleFilter, setVisibleFilter] = React.useState(false);
    const [visibleDetail, setVisibleDetail] = React.useState(false);
    const [data, setData] = React.useState([])
    const [detail, setDetail] = React.useState([])
    const dispatch = useDispatch();
    useEffect(() => {
        getData()
    }, [])

    const getData = () => {
        api.create().getPembayaran().then(response => {
            console.log(response);
            if (response.data.data != false) {
                let temp = []
                response.data.data.map(el => {
                    console.log(el);
                    if (el.his_payment_status === "Pembayaran Selesai" || el.his_payment_status === "Cancelled") {
                        temp.push({
                            kodeTransaksi: el.transaction_no,
                            tgl: el.transaction_date,
                            rekamMedis: el.medical_record_no,
                            namaPasien: el.name,
                            kodeReservasi: el.booking_id,
                            statusOnline: el.online_payment_status,
                            statusHis: el.his_payment_status,
                            tglTagihan: el.payment_date,
                            id: el.id
                        })
                    }
                })
                console.log(temp);
                setData(temp)
            }
        })
    }

    const columns = [
        {
            name: "kodeTransaksi",
            label: "Kode Transaksi",
        },
        {
            name: "tgl",
            label: "Tanggal Transaksi",
        },
        {
            name: "rekamMedis",
            label: "No Rekam Medis",
        },
        {
            name: "namaPasien",
            label: "Nama Pasien"
        },
        {
            name: "kodeReservasi",
            label: "Kode Reservasi"
        },
        {
            name: "statusOnline",
            label: "Status Pembayaran Online"
        },
        {
            name: "statusHis",
            label: "Status Pembayaran HIS"
        },
        {
            name: "tglTagihan",
            label: "Tanggal Pembayaran"
        }, 
        {
            name: "Aksi",
            options: {
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center', placeContent: 'center' }}>
                            <button
                                title="Edit"
                                onClick={() => handleSeeDetail(tableMeta)}
                                style={{
                                    backgroundColor: "transparent",
                                    fontSize: 20,
                                    outline: 'none',
                                    borderColor: 'transparent',
                                    marginRight: 20
                                }}>
                                <img src={editIcon} style={{width: 30, height: 30}} />
                            </button>
                            <div
                                style={{width: 29, height: 29, borderRadius: 90, backgroundColor: '#65ae92', alignSelf: 'center', cursor: 'pointer'}}
                                onClick={() => doPrint()}
                                title="Print"
                            >
                                <img src={print} style={{marginLeft: 5, marginTop: 6}} />

                            </div>
                        </div>
                    )
                }
            }
        },
        {
            name: "id",
            options: {
                display: false,
                filter: false
            }
        }];

    const doPrint = () => {

    }

    // const options = {
    //     filterType: 'checkbox',
    //     // pagination: false,
    //     filter: false,
    //     sort: false,
    //     print: false,
    //     download: false,
    //     selectableRows: false,
    //     viewColumns: false,
    //     search: false,
    //     rowsPerPage: 10,
    //     responsive: 'scrollMaxHeight',
    // };

    const onOpen = () => {
        setVisibleCreate(true);
    };

    const onClose = () => {
        setVisibleCreate(false);
        setVisibleFilter(false);
        setVisibleDetail(false);
    };

    const handleSeeDetail = ({ rowData }) => {
        const id = rowData[rowData.length - 1]
        api.create().getPembayaranDetail(id).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    const sentData = response.data.data
                    history.push({
                        pathname: '/pembayaran/detail-monitoring',
                        name: 'Detail Pembayaran',
                        state: {
                            sentData,
                        }
                    })
                }
            }
        })
    };

    return (
        <div style={{ paddingTop: 20, }}>
            <div style={{ justifyContent: 'flex-end', marginRight: 1 }}>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 30 }}>
                    {/* <div onClick={(() => setVisibleFilter(true))} style={{ height: 32, width: 40, backgroundColor: 'white', borderRadius: 20, marginRight: 10, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                        <img
                            style={{ margin: 'auto', width: 20, marginLeft: 10, marginTop: 5 }} src="https://img.icons8.com/android/24/000000/menu.png" />
                    </div> */}
                    {/* <div style={{ height: 32, width: 50, backgroundColor: 'white', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999' }} >
                        <img src={download} />
                    </div> */}
                </div>
                <div>
                <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                        data={data}
                        columns={columns}
                        options={options}
                    />
                </MuiThemeProvider>

                </div>
            </div>
            {/* <div style={{ marginTop: 20, boxShadow: '5px 2px 10px 0 #999999', borderRadius: 30 }}> */}
            {/* </div> */}

            {visibleCreate ?
                <AddDocter
                    onClose={onClose}
                /> : null}

            {visibleFilter ?
                <FilterDocter
                    onClose={onClose} /> : null}
        </div>
    )
}